<template>
  <v-menu
    open-on-hover
    :open-delay="openDelay"
    :close-delay="closeDelay"
    location="bottom center"
    offset="8"
  >
    <template #activator="{ props }">
      <app-icon-ds 
        v-bind="props"
        :icon="icon"
        :size="size"
        class="cursor-pointer ml-2"
      />
    </template>

    <v-card class="pa-4" elevation="4" :max-width="maxWidth">
      <slot />
    </v-card>
  </v-menu>
</template>

<script lang="ts" setup>
const props = defineProps<{
  icon?: string
  size?: string
  maxWidth?: number | string
  openDelay?: number
  closeDelay?: number
}>()

const {
  icon = 'fa-circle-info',
  size = 'xs',
  maxWidth = 340,
  openDelay = 80,
  closeDelay = 150,
} = props
</script>
